import React, { createContext, useState, useEffect} from 'react';

export const ProductContext = createContext({
  selectedProduct: null,
  selectedPlan: null,
  setSelectedProduct: () => {},
  setSelectedPlan: () => {}
});

export const ProductProvider = ({ children }) => {
    const [selectedProduct, setSelectedProductState] = useState(() => {
      const savedProduct = localStorage.getItem('selectedProduct');
      return savedProduct ? JSON.parse(savedProduct) : null;
    });
    
    const [selectedPlan, setSelectedPlanState] = useState(() => {
      const savedPlan = localStorage.getItem('selectedPlan');
      return savedPlan ? JSON.parse(savedPlan) : null;
    });
  
    const setSelectedProduct = (product) => {
      setSelectedProductState(product);
      localStorage.setItem('selectedProduct', JSON.stringify(product));
    };
  
    const setSelectedPlan = (plan) => {
      setSelectedPlanState(plan);
      localStorage.setItem('selectedPlan', JSON.stringify(plan));
    };
  return (
    <ProductContext.Provider 
      value={{ 
        selectedProduct, 
        setSelectedProduct, 
        selectedPlan, 
        setSelectedPlan 
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};